<ub-filter-list>
  <span label><ng-container i18n>Show</ng-container>:</span>


  <!-- historyFilter
  <button *ngIf="sort.id !== active" mat-button color="primary" (click)="onSelect(sort)">{{ sort.name }}</button>
  <button *ngIf="sort.id === active" mat-button disabled="true">{{ sort.name }}</button> -->

  <ub-simple-list filters>
    @for (filter of filters; track filter) {
      <ub-simple-list-item>
        <button mat-button [color]="filter.isActive ? 'default' : 'accent'" (click)="setHistory(filter.value)"
        [disabled]="filter.isActive">{{ filter.title }}</button>
      </ub-simple-list-item>
    }
  </ub-simple-list>
</ub-filter-list>

<ub-simple-list type="block">
  @for (item of filtered; track item) {
    <ub-simple-list-item>
      @if (item.type === 'relation') {
        <eas-relation-title [id]="item.id"></eas-relation-title>
      }
      @if (item.type === 'user_dependent') {
        <eas-roles-title [roles]="[item.id]"></eas-roles-title>
      }
      <ub-simple-list type="block">
        @for (rec of item.history; track rec) {
          <ub-simple-list-item>
            <ub-label label="{{ rec.start | date }} - {{ rec.end | date }} -">
              @if (item.type === 'relation') {
                <span text>
                  @for (cat of rec.value ?? []; track cat) {
                    <eas-relation-category-title [id]="item.id" [category]="cat">
                    </eas-relation-category-title>
                  }
                </span>
              }
              @if (item.type === 'user_dependent') {
                <span text>
                  @for (cat of rec.value ?? []; track cat) {
                    <eas-user-title [username]="cat"></eas-user-title>
                  }
                </span>
              }
            </ub-label>
          </ub-simple-list-item>
        }
      </ub-simple-list>
    </ub-simple-list-item>
  }
</ub-simple-list>
